import PaiTextField from 'features/ui/base-components/pai-text-field';
import React from 'react';
import { BasicActionDialog } from '../../../ui/base-dialogs';

interface Props {
  open: boolean;
  name: string;

  handleTextFieldChange(type: string): (event: React.ChangeEvent<HTMLInputElement>) => void;

  handleClose(): void;

  handleProceed(): void;
}

const CreateQuestionnaireDialog: React.FC<Props> = ({ open, name, handleTextFieldChange, handleProceed, handleClose }) => {
  return (
    <BasicActionDialog
      open={open}
      maxWidth={'xs'}
      dialogTitle={'Name der Umfrage'}
      cancelButtonText={'Abbrechen'}
      proceedButtonText={'OK'}
      handleClose={handleClose}
      handleProceed={handleProceed}
      proceedButtonDisabled={name.trim() === ''}
    >
      <PaiTextField value={name} onChange={handleTextFieldChange('name')} placeholder={'Name zu bewertender Führungskraft...'} />
    </BasicActionDialog>
  );
};

export default CreateQuestionnaireDialog;
